import React from 'react';
import {
  format,
  getDay,
  setISODay,
  subWeeks,
} from 'date-fns';
import FormSelect from '../FormInput/FormSelect';

class BaseWeekSelector extends React.Component {
  onDateChange = (e, { value }) => {
    const val = value === 'all' ? null : value;
    this.props.onDateChange(val);
  };

  render() {
    const {
      className,
      selectedDate,
      displayFormat,
      earliestDate,
      latestDate,
      noFilterTitle,
      mostRecentWeekDate,
    } = this.props;

    /**
     * if NO label is passed, default it to 'As of', however if we specifically
     * pass `false` as a label, then we specifically don't show it.
     * or if an actual label is passed, obviously show that
     */
    let { label } = this.props;
    label = typeof label === 'undefined' ? 'As of' : label;

    // when selectedDate comes back as null, set to 'all'
    const selected = !!selectedDate ? format(selectedDate, 'YYYY-MM-DD') : ( !!noFilterTitle ? 'all' : '' );

    return (
      <div className={`BaseWeekSelector date-selector ${className || ''}`}>
        {label && <label>{label}</label>}
        <WeekPicker
          placeholder="Please select a date"
          selectedDate={selected}
          onWeekChange={this.onDateChange}
          displayFormat={displayFormat}
          earliestDate={earliestDate}
          latestDate={latestDate}
          mostRecentViewableDay={mostRecentWeekDate}
          noFilterTitle={noFilterTitle}
        />
      </div>
    );
  }
}

const WeekPicker = ({
  placeholder,
  onWeekChange,
  selectedDate,
  displayFormat = 'MMMM DD, YYYY',
  earliestDate,
  latestDate,
  mostRecentViewableDay,
  noFilterTitle,
}) => {
  // add weekly dates less than or equal to mostRecentViewableDay and 
  // greater than earliestDate where mostRecentViewableDays is the day 
  // of week for each date
  let weeklyDates = [];
  let weekEndingDate = mostRecentViewableDay;

  if (noFilterTitle) {
    weeklyDates.push({ key: 0, text: noFilterTitle, value: undefined });
  }

  let idx = 1;
  while (idx <= 6) {
    if (subWeeks(weekEndingDate, idx - 1) >= new Date(earliestDate)) {
      weeklyDates.push({
        key: noFilterTitle ? idx + 1 : idx,
        text: format(subWeeks(weekEndingDate, idx - 1), displayFormat),
        value: format(subWeeks(weekEndingDate, idx - 1), 'YYYY-MM-DD'),
      });
    }
    idx++;
  }

  return (
    <FormSelect
      options={weeklyDates}
      onChange={onWeekChange}
      value={selectedDate}
    />
  );
};


export default BaseWeekSelector;
